module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray-10bb4ce606035109159a802136fc94fd.png";